import React from "react";
import { createRoot } from "react-dom/client";
import {
  BrowserRouter,
  useLocation,
  useNavigate,
  useRoutes,
} from "react-router-dom";
import AppRoute from "./config/app-route.jsx";

// bootstrap
import "bootstrap";

// css
import "@fortawesome/fontawesome-free/css/all.css";
import "react-perfect-scrollbar/dist/css/styles.css";
import "./index.css";
import "./commonstyle.css";
import "./scss/react.scss";
import { Provider } from "react-redux";
import { store } from "./_store";
import { history } from "./_helpers/history.js";
import ErrorBoundary from "./pages/error/ErrorBoundary.js";
import { initGA } from "./googleAnalytics.js";

const container = document.getElementById("root");
const root = createRoot(container);

initGA();

function App() {
  history.navigate = useNavigate();
  history.location = useLocation();
  let element = useRoutes(AppRoute);
  return element;
}

root.render(
  <Provider store={store}>
    <ErrorBoundary>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ErrorBoundary>
  </Provider>
);
